import DualLogoHeader from './DualLogoHeader';
import type { OAuthPartnerBranding } from '../types/oauthSession';

interface PartnerConnectIntroProps {
  partner: OAuthPartnerBranding;
  isSignUp?: boolean;
}

export default function PartnerConnectIntro({
  partner,
  isSignUp = false,
}: PartnerConnectIntroProps) {
  return (
    <div className='mb-6'>
      <DualLogoHeader
        partnerName={partner.displayName}
        partnerLogoUrl={partner.logoUrl}
        partnerIconUrl={partner.iconUrl}
        partnerBrandColor={partner.brandColor}
      />
      <p className='text-center text-sm text-gray-600 dark:text-gray-400 leading-relaxed'>
        {isSignUp ? (
          <>
            Create your{' '}
            <span className='font-semibold text-gray-900 dark:text-gray-100'>6Tool</span> account to
            connect with{' '}
            <span className='font-semibold text-gray-900 dark:text-gray-100'>
              {partner.displayName}
            </span>
            .
          </>
        ) : (
          <>
            Connect your{' '}
            <span className='font-semibold text-gray-900 dark:text-gray-100'>6Tool</span> account
            with your{' '}
            <span className='font-semibold text-gray-900 dark:text-gray-100'>
              {partner.displayName}
            </span>{' '}
            account.
          </>
        )}
      </p>
    </div>
  );
}
